// このファイルは tools/curriculum/job-diagnosis-path/pull.ts が書く。手で直さない
// 本番の学習パス (既定のパス) の公開中の項目を章ごとに数えたもの。章の始まりの印は数えない
import type { PathChapter } from "./job-diagnosis-path";

export const PATH_FETCHED_AT = "2026-10-18T10:50:36.159Z";

export const PATH_TOTAL_ITEMS = 197;

export const CHAPTERS: readonly PathChapter[] = [
  { no: 1, title: "第1章 はじめに編", items: 16 },
  { no: 2, title: "第2章 IT・開発リテラシー編", items: 13 },
  { no: 3, title: "第3章 AI活用編", items: 16 },
  { no: 4, title: "第4章 Linux基礎編", items: 8 },
  { no: 5, title: "第5章 コンピュータサイエンス基礎編", items: 11 },
  { no: 6, title: "第6章 データベース・SQL編", items: 17 },
  { no: 7, title: "第7章 Python入門編", items: 17 },
  { no: 8, title: "第8章 Git基礎編", items: 6 },
  { no: 9, title: "第9章 バックエンド開発編", items: 26 },
  { no: 10, title: "第10章 ECサイト構築編", items: 1 },
  { no: 11, title: "第11章 モダンWeb・フルスタック編", items: 17 },
  { no: 12, title: "第12章 タスク管理アプリ編", items: 3 },
  { no: 13, title: "第13章 AIエンジニアリング編", items: 15 },
  { no: 14, title: "第14章 AIチャットアプリ編", items: 3 },
  { no: 15, title: "第15章 インフラ・クラウド編", items: 4 },
  { no: 16, title: "第16章 分析ダッシュボード編", items: 4 },
  { no: 17, title: "第17章 実践・キャリア編", items: 19 },
];
